export default "__VITE_ASSET__CZnSFCxu__"